// A link goes somewhere on the web, or nowhere: never `javascript:`.
// meets: code/edits-are-data
export function safeHref(href: unknown): string {
  const h = String(href ?? "").trim();
  return /^(https?:|mailto:|#|\/(?!\/))/i.test(h) ? h : "#";
}
